import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import { loadingBarReducer } from 'react-redux-loading-bar';
import { routerReducer } from 'react-router-redux';
import {
  AUTH_DISCARD_USER,
  REVERSE_USER,
  CHANGE_SHOP,
  RESET_SHOP,
} from './app/auth/constants';
import auth from './app/auth/reducer';
import appointments from './app/main/appointments/reducer';
import barbers from './app/main/barbers/reducer';
import shops from './app/main/shops/reducer';
import customers from './app/main/customers/reducer';
import services from './app/main/services/reducer';
import settings from './app/main/settings/reducer';
import reports from './app/main/reports/reducer';
import main from './app/main/reducer';
import admin from './app/admin/reducer';
import search from './app/main/search/reducer';
import products from './app/products/reducer';
import shopify from './app/products/products/Shopify/reducer/reducer';
import mailchimp from './app/main/settings/integrations/Mailchimp/reducer/reducer';
import payment from './app/main/payment/reducer';
import listeningMode from './app/listeningMode/reducer';
import register from './app/register/reducer';
import timer from './app/main/timeTracker/reducers';
import analytics from './app/main/reports/analytics/reducer';
import waitingListCustomers from './app/main/waitingList/waitingListCustomers/reducer';
import engagement from './app/engagement/reducer';
import queue from './app/queue/reducer';
import receipts from './app/customer/receipts/reducer';
import confirmModal from './app/common/confirmModal/reducer';
import cart from './app/cart/reducer';
import handoff from './app/handoff/reducer';
import { isDirtyReducer as rangeFilter } from './app/common/RangeFilter/reducer';
import isContainerApp from './app/containerApp/reducer';
import isLoadingList from './app/common/hoc/withLoaingList/reducer';
import memberships from './app/memberships/reducer';
import loans from './app/loans/reducer';
import { uiReducer } from './modules/infra/dls/breakpoints/store';
import { twoFa } from './modules/shared/auth/two-fa/store';
import { reducer as loginReducer } from './modules/shared/auth/login/store';

const shopResetActions = [
  CHANGE_SHOP,
  RESET_SHOP,
  REVERSE_USER,
];

export const resetOnChangeShop = reducer => (state, action) => {
  if (shopResetActions.includes(action.type)) {
    return reducer(undefined, action);
  }
  return reducer(state, action);
};

const createAppReducer = (asyncReducers = {}) => (
  combineReducers({
    form,
    auth,
    appointments: resetOnChangeShop(appointments),
    barbers: resetOnChangeShop(barbers),
    shops: resetOnChangeShop(shops),
    customers: resetOnChangeShop(customers),
    services: resetOnChangeShop(services),
    settings: resetOnChangeShop(settings),
    reports: resetOnChangeShop(reports),
    main,
    loadingBar: loadingBarReducer,
    routing: routerReducer,
    admin,
    search,
    products: resetOnChangeShop(products),
    shopify,
    mailchimp,
    payment: resetOnChangeShop(payment),
    listeningMode: resetOnChangeShop(listeningMode),
    register: resetOnChangeShop(register),
    timer: resetOnChangeShop(timer),
    analytics: resetOnChangeShop(analytics),
    waitingListCustomers: resetOnChangeShop(waitingListCustomers),
    engagement: resetOnChangeShop(engagement),
    queue: resetOnChangeShop(queue),
    receipts: resetOnChangeShop(receipts),
    confirmModal,
    cart: resetOnChangeShop(cart),
    handoff,
    rangeFilter,
    isContainerApp,
    isLoadingList,
    memberships: resetOnChangeShop(memberships),
    loans: resetOnChangeShop(loans),
    ui: uiReducer,
    login: loginReducer,
    twoFa,
    ...asyncReducers,
  })
);

const createRootReducer = (asyncReducers) => {
  const appReducer = createAppReducer(asyncReducers);

  return (state, action) => {
    if (action.type === AUTH_DISCARD_USER) {
      // Clear store
      return appReducer(undefined, action);
    }

    return appReducer(state, action);
  };
};

export default createRootReducer;
